export default __webpack_public_path__ + "static/media/1.4cc26c67.jpg";